import { formatPrice } from "@/lib/shopify";
import { ShoppingBag } from "lucide-react";

export default function ProductCard({ product, onSelect }) {
  const image = product.featuredImage || product.images?.edges?.[0]?.node;
  const minPrice = product.priceRange?.minVariantPrice;
  const maxPrice = product.priceRange?.maxVariantPrice;
  const priceLabel =
    minPrice && maxPrice && minPrice.amount !== maxPrice.amount
      ? `${formatPrice(minPrice)} – ${formatPrice(maxPrice)}`
      : formatPrice(minPrice);

  return (
    <button
      type="button"
      onClick={() => onSelect(product)}
      className="card-lift group text-left bg-white rounded-2xl overflow-hidden ring-1 ring-gray-200 shadow-sm flex flex-col"
      data-testid={`product-card-${product.handle}`}
    >
      <div className="relative aspect-square bg-cream overflow-hidden">
        {image ? (
          <img
            src={image.url}
            alt={image.altText || product.title}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-navy-deep/30">
            <ShoppingBag size={48} />
          </div>
        )}
        {!product.availableForSale && (
          <span className="absolute top-3 left-3 bg-navy text-white text-[10px] uppercase font-display tracking-widest px-2 py-1 rounded">
            Sold Out
          </span>
        )}
      </div>
      <div className="p-5 flex flex-col flex-1">
        {product.productType && (
          <p className="font-display tracking-[0.22em] text-[10px] uppercase text-green-brand">
            {product.productType}
          </p>
        )}
        <h3 className="mt-1 font-display tracking-wide text-navy text-lg leading-tight">
          {product.title}
        </h3>
        <span className="mt-2 inline-block h-[2px] w-10 bg-green-brand" />
        <p className="mt-3 text-navy font-semibold">{priceLabel}</p>
        {product.tags?.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-1.5">
            {product.tags.slice(0, 3).map((t) => (
              <span
                key={t}
                className="inline-block text-[10px] uppercase tracking-wider font-display text-navy-deep/70 bg-gray-soft px-2 py-0.5 rounded"
              >
                {t}
              </span>
            ))}
          </div>
        )}
      </div>
    </button>
  );
}
